"use strict";

import Global from "/js/core/global.js";
import Metrics from "/js/util/metrics.js";
import Constants from "/js/core/constants.js";
import PrimerMaster from "/js/util/primermaster.js";
import AnimSequencer from "/js/util/anim-sequencer.js";
import UserLessons from "/js/core/user-lessons.js";

/**
 * CSS-related util functions.
 */
export default class CssUtil {

  /**
   * Simply tests for "visibility:visible".
   *
   * (jQuery selectors ":visible" and ":hidden" are misleading, should be avoided IMO)
   */
  static isVisible($el) {
    return ($el.css("visibility") === "visible");
  }

  static isDisplayBlock($el) {
    return ($el.css("display") === "block");
  }
}